export default function formatCurrency(number, currencyCode) {
  let currency = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode ?? "NGN",
    currencyDisplay: "narrowSymbol",
  });
  return currency.format(number);
}
